export default __webpack_public_path__ + "static/media/flitaa-logo-white.6529a9c3.svg";